import { SET_CONFIRMATION_MODAL_STATE } from '../actions/types'

const defaultState = {
  confirmationModalVisible: false,
  header: '',
  confirmationMessage: 'createContact',
  confirmFunc: () => {
    console.log(
      'default confirm func, you need to input your own confirm func',
    )
  },
  confirmFuncArgs: {},
}

const confirmationModalState = (state = defaultState, action) => {
  const { type, payload } = action
  switch (type) {
    case SET_CONFIRMATION_MODAL_STATE:
      return {
        ...state,
        ...payload,
      }
    default:
      return state
  }
}
export default confirmationModalState
